import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Image,
  ListGroup,
} from "react-bootstrap";

const COLORS = {
  gold: "#E5B04C",
  goldSoft: "#E6CA5D",
  dark: "#1C1C1C",
  blue: "#B4C3F2",
  white: "#fff",
};

const initialMessages = [
  {
    username: "Herr Müller",
    timestamp: "12.07.2025, 10:13",
    text: "Guten Tag, Ihre Anfrage ist bei uns eingegangen.",
  },
  {
    username: "Sie",
    timestamp: "12.07.2025, 11:10",
    text: "Vielen Dank, ich freue mich auf das Angebot!",
  },
  {
    username: "Herr Müller",
    timestamp: "12.07.2025, 11:15",
    text: "Wir werden uns zeitnah bei Ihnen melden.",
  },
  {
    username: "Frau Schmitz",
    timestamp: "12.07.2025, 12:22",
    text: "Ihr Kostenvoranschlag ist im Anhang. Für Rückfragen stehen wir gerne zur Verfügung.",
  },
  {
    username: "Sie",
    timestamp: "12.07.2025, 12:43",
    text: "Super, vielen Dank! Ich prüfe alles und gebe Rückmeldung.",
  },
  {
    username: "Herr Müller",
    timestamp: "12.07.2025, 13:02",
    text: "Sehr gerne. Wir wünschen Ihnen ein schönes Wochenende!",
  },
  {
    username: "Sie",
    timestamp: "13.07.2025, 08:18",
    text: "Ihnen ebenfalls! Bis bald.",
  },
];

function App() {
  const [messages, setMessages] = useState(initialMessages);
  const [newMessage, setNewMessage] = useState("");
  const firstName = "Max";
  const lastName = "Mustermann";

  const handleSend = (e) => {
    e.preventDefault();
    if (newMessage.trim() === "") return;
    const now = new Date();
    const timestamp = now
      .toLocaleString("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
      .replace(",", "");
    const newMsg = {
      username: "Sie",
      timestamp: timestamp,
      text: newMessage,
    };
    setMessages([...messages, newMsg]);
    setNewMessage("");
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: `linear-gradient(135deg, ${COLORS.blue} 0%, ${COLORS.goldSoft} 100%)`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Container fluid className="py-5" style={{ minHeight: "100vh" }}>
      <br></br>
        <Row className="justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
          <Col xs={12} md={10} lg={8} xl={6} style={{ display: "flex", justifyContent: "center" }}>
            <Card
              className="shadow-lg"
              style={{
                borderRadius: 28,
                background: COLORS.white,
                border: "none",
                padding: "2.5rem 1.5rem 1.4rem 1.5rem",
                position: "relative",
                maxWidth: 540,
                width: "100%",
                margin: "auto",
              }}
            >
              {/* Firmenlogo */}
              <div className="text-center mb-3">
                <Image
                  src="https://wurster-rehazentrum.de/wp-content/uploads/2023/11/logo-desktop.svg"
                  alt="Firmenlogo"
                  style={{
                    maxWidth: 96,
                    borderRadius: 20,
                    background: COLORS.gold,
                    padding: 9,
                    marginBottom: 9,
                    boxShadow: `0 0 0 4px ${COLORS.goldSoft}, 0 2px 16px 0 #0002`,
                  }}
                  fluid
                />
              </div>
              {/* Begrüßung */}
              <div className="text-center mb-4">
                <h4 style={{ fontWeight: 700, color: COLORS.dark }}>
                  Hallo, {firstName} {lastName}
                </h4>
                <p style={{ color: COLORS.dark, fontSize: 18, opacity: 0.88 }}>
                  Wir danken Ihnen für Ihren geschätzten Auftrag.<br />
                  Anbei können Sie Nachrichten verfassen.
                </p>
              </div>
              {/* Chatbereich */}
              <div
                style={{
                  background: "#f7f6f2",
                  borderRadius: 18,
                  minHeight: 320,
                  maxHeight: 480,
                  overflowY: "auto",
                  marginBottom: 25,
                  boxShadow: "0 1px 8px 0 #e5b04c22",
                  transition: "max-height 0.3s",
                }}
              >
                <ListGroup variant="flush">
                  {messages.map((msg, idx) => (
                    <ListGroup.Item
                      key={idx}
                      style={{
                        background: "transparent",
                        border: "none",
                        padding: "15px 22px 5px 22px",
                      }}
                    >
                      <div style={{ fontWeight: 500, color: COLORS.dark }}>
                        {msg.username}
                        <span
                          style={{
                            color: "#a38925",
                            fontSize: "0.96em",
                            fontWeight: 400,
                            marginLeft: 7,
                          }}
                        >
                          hat verfasst am {msg.timestamp}:
                        </span>
                      </div>
                      <div
                        style={{
                          marginTop: 3,
                          padding: "9px 13px",
                          background: COLORS.blue + "22",
                          borderRadius: 9,
                          color: COLORS.dark,
                          fontSize: 16,
                          wordBreak: "break-word",
                        }}
                      >
                        {msg.text}
                      </div>
                    </ListGroup.Item>
                  ))}
                  {messages.length === 0 && (
                    <div className="text-center text-muted p-3">
                      Noch keine Nachrichten vorhanden.
                    </div>
                  )}
                </ListGroup>
              </div>
              {/* Nachricht verfassen */}
              <Form onSubmit={handleSend} className="mt-2" autoComplete="off">
  <div style={{ position: "relative"}}>
    <Form.Control
      as="textarea"
      rows={10}
      placeholder="Nachricht verfassen …"
      value={newMessage}
      maxLength={1200}
      onChange={(e) => setNewMessage(e.target.value)}
      style={{
        borderRadius: 16,
        border: "1.5px solid " + COLORS.goldSoft,
        background: "#fafafa",
        boxShadow: "0 1px 5px 0 #e5b04c0a",
        fontSize: 16,
        resize: "vertical",
        minHeight: 180,
        paddingRight: 130, // Platz für Button, damit Text nicht darunter läuft
      }}
    />
    <br></br>
    <br></br>
    
    <Button
      type="submit"
      style={{
        background: `linear-gradient(100deg, ${COLORS.gold} 55%, ${COLORS.goldSoft} 100%)`,
        border: "none",
        borderRadius: 20,
        color: COLORS.dark,
        fontWeight: 700,
        fontSize: 18,
        boxShadow: "0 2px 10px 0 #e5b04c55",
        padding: "0.6rem 2.1rem",
        letterSpacing: 0.5,
        transition: "all 0.18s cubic-bezier(.55,.07,.85,.99)",
        zIndex: 2,
      }}
      onMouseOver={e =>
        (e.currentTarget.style.background = `linear-gradient(90deg, ${COLORS.goldSoft} 0%, ${COLORS.gold} 100%)`)
      }
      onMouseOut={e =>
        (e.currentTarget.style.background = `linear-gradient(100deg, ${COLORS.gold} 55%, ${COLORS.goldSoft} 100%)`)
      }
      disabled={newMessage.trim().length === 0}
    >
      Senden
    </Button>
  </div>
</Form>
              {/* CI-Fußzeile */}
              <br></br>
              <div
                className="text-center mt-4"
                style={{ fontSize: 13, color: COLORS.gold, opacity: 0.75 }}
              >
                Sanitätshaus Wurster &nbsp;·&nbsp; {new Date().getFullYear()}
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default App;
